import { type ReactNode, useState } from "react";

import type { Action } from "../../action/Action";
import ConfirmDialog from "./ConfirmDialog";

type UseDialogConfirmProps = {
    message: string;
    confirmLabel?: string;
    onConfirm: Action;
};

export function useDialogConfirm(props: UseDialogConfirmProps): [() => void, ReactNode] {
    const { message, confirmLabel = "Supprimer", onConfirm } = props;
    const [visible, setVisible] = useState(false);
    return [
        () => setVisible(true),
        <ConfirmDialog
            message={message}
            confirmLabel={confirmLabel}
            onConfirm={onConfirm}
            visible={visible}
            onCancel={() => setVisible(false)}
        />,
    ];
}
